import React from 'react';

import "./styles.sass";

import { FaEdit } from 'react-icons/fa';

const BannerEditorButton = (props) => {
    const onClickEditor = () => {
        return props.onClickEditor()
    }

    return (
        <div className="banner-header-buttons">
            <button className="has-text-weight-bold button-header is-size-5" onClick={() => onClickEditor()}>
                <FaEdit className="edit-button" /> editor
            </button>
        </div>
    );
}

export default BannerEditorButton